import { render, staticRenderFns } from "./ChangeReportForm.vue?vue&type=template&id=8ba7f28e"
import script from "./ChangeReportForm.vue?vue&type=script&lang=js"
export * from "./ChangeReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports